module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--euro-6fea254387c9579e355c13634dad8acc.webp";